import Ajax from "Utils/ajax";
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data);
export const getStaffList = (data) => Ajax.post('hr/getStaffList',data); 
export const getAllStaff = (data) => Ajax.post('hr/getAllStaff',data);
export const getAllActiveDeactiveStaff = (data) => Ajax.post('hr/getAllActiveDeactiveStaff',data);
export const getAwardList = (data) => Ajax.post('hr/getAwardList',data);
export const getStaffAwardList = (data) => Ajax.post('setting/getStaffAwardList',data);
export const getMainUsers = (data) => Ajax.post('hr/getMainUsers',data);
export const staffAward = (data) => Ajax.post('hr/staffAward',data);
export const removeStaffAWard = (data) => Ajax.post('hr/removeStaffAWard',data);